export const LikelihoodLabelMap = {
    'likelihood-00': 'Uncommon',
    'likelihood-10': 'Common',
    'likelihood-20': 'Very Common',
    'likelihood-30': 'Typical',
    'likelihood-40': 'Pathognomonic',
};
//# sourceMappingURL=consts.js.map